import React from "react";

const CustomDivider = () => (
    <img className="container" src={process.env.PUBLIC_URL + "/pictures/divider.png"} alt="divider" />
);

export default CustomDivider;